import { Model } from '@models'
import { Caching } from '@utils'
import { Calendar } from '@src/models/app.types'
import { calendarDateSelector } from '@src/selectors/app'
import nutritionReducers from './reducers'
import { defaultDailyNutritionState } from './constants'
import ALL_NUTRITION from './graphql/allNutrition'
import { isTrustedHistoricalDailyNutritionCacheEntry } from './cache'

export default class DailyNutrition {
  namespace = 'dailyNutrition'

  state = {
    ...Model.defaultState,
    ...defaultDailyNutritionState,
  }

  effects = {
    fetch: Model.buildEffect({
      name: `${this.namespace}/fetch`,
      query: ALL_NUTRITION,
      dataPath: 'allNutrition',
      *variables(payload: any, { select }: any) {
        let queryVariables = payload

        if (!queryVariables?.filter?.startDate || !queryVariables?.filter?.endDate) {
          const { startDate, endDate }: Partial<Calendar> = yield select(calendarDateSelector)
          queryVariables = { filter: { startDate, endDate } }
        }

        return queryVariables
      },
      caching: (variables) => Caching.shouldUseDateRangeCache(variables?.filter),
      cacheKey: (variables) => Caching.listFilterCacheKey(`${this.namespace}/fetch`, variables),
      shouldUseCacheEntry: (cacheEntry, variables) =>
        isTrustedHistoricalDailyNutritionCacheEntry({
          cacheEntry,
          filter: variables?.filter,
        }),
      reducers: [{ name: 'setNutrition' }],
    }),

    setGlucoseThresholdsUpdated: Model.buildEffect({
      name: `${this.namespace}/setGlucoseThresholdsUpdated`,
      reducers: [{ name: 'glucoseThresholdsUpdated' }],
    }),
  }
  reducers = nutritionReducers
}
